/**
 * Represents every content type in Django. Since Django stores these as integer values, this model helps to give them
 * human-readable names when dealing with these values in API responses (like in Marketplace)
 */
export enum IngageContentType {
  LOGENTRY = 1,
  PERMISSION = 2,
  GROUP = 3,
  CONTENTTYPE = 4,
  SESSION = 5,
  SITE = 6,
  FLATPAGE = 7,
  APPLICATION = 8,
  GRANT = 9,
  ACCESSTOKEN = 10,
  REFRESHTOKEN = 11,
  TASKMETA = 12,
  TASKSETMETA = 13,
  INTERVALSCHEDULE = 14,
  CRONTABSCHEDULE = 15,
  PERIODICTASKS = 16,
  PERIODICTASK = 17,
  WORKERSTATE = 18,
  TASKSTATE = 19,
  USER = 20,
  USERPROFILE = 21,
  CONTENT = 22,
  VERSION = 23,
  ASSET = 24,
  BUSINESS = 25,
  PUBLICFILE = 26,
  SHAREPRIVATE = 27,
  SHAREPUBLICSEEN = 28,
  SUBSCRIBER = 29,
  STOCKIMAGE = 30,
  PAYMENT = 31,
  TIER = 32,
  MEMBERSHIP = 33,
  CORSMODEL = 34,
  CONTENTIDLIST = 35,
  CATEGORY = 36,
  FAVORITECONTENTIDLIST = 37,
  FEATURETOGGLE = 38,
  LISTING = 39,
  ASSOCIATION = 40,
  NONCE = 41,
  USERSOCIALAUTH = 42,
  CODE = 43,
  PARTIAL = 44,
  MOMENTCONTENTIDLIST = 45,
  SHORTURL = 46,
  SNPOST = 47,
  SNTOKEN = 48,
  SNPERFORMANCELOG = 49,
  COMPANYUSER = 50,
  COMPANY = 51,
  ROLE = 52,
  TEAM = 53,
  USERINVITEVERIFICATIONLINK = 54,
  TEAMUSER = 55,
  CONTENTSHARELOG = 56,
  CONTENTSHARERECIPIENT = 57,
  AFFILIATE = 58,
  TEAMEVENTENTRY = 59,
  POSTVENDING = 60,
  TEAMANALYTICSREPORTS = 61,
  FONT = 62,
  SETTING = 63,
  THEME = 64,
  PROFILE = 65,
  REQUEST = 66,
  RESPONSE = 67,
  SQLQUERY = 68,
  TEAMANALYTICSSAVEDREPORTS = 97,
  APIKEY = 98,
  MESSAGE = 99,
  MARKETPLACECONTENT = 130,
  MARKETPLACEITEM = 131,
  MARKETPLACELISTING = 132,
  MARKETPLACECATEGORY = 133,
  MARKETPLACELISTINGCATEGORY = 134,
  MARKETPLACELISTINGASSET = 135,
}
